import { paths } from '@farmersdog/constants';
import type { DefaultAppNavProps } from '@farmersdog/corgi-x';

// whyFreshTitle is currently found at website/src/pages/WhyFresh/data
const whyFreshTitle = 'Why Fresh?';

export const leftItems: DefaultAppNavProps['leftItems'] = [
  {
    label: 'Reviews',
    type: 'anchor',
    href: paths.PATH_REVIEWS,
  },
  {
    label: 'About Us',
    type: 'anchor',
    href: paths.PATH_ABOUT_US,
  },
  {
    label: whyFreshTitle,
    type: 'anchor',
    href: paths.PATH_WHY_FRESH,
  },
  {
    label: 'FAQ',
    type: 'anchor',
    href: paths.PATH_FAQ,
  },
];

const rightItems: DefaultAppNavProps['rightItems'] = [
  {
    label: 'Log In',
    type: 'anchor',
    href: paths.PATH_LOGIN,
    alwaysVisible: true,
  },
];

export function useItems() {
  return {
    leftItems,
    rightItems,
  };
}
